"use client"

import type { ReactNode } from "react"

import React from "react"

import { useShoppingContext } from "#modules/cart/context/cart.context"
import { CartItem } from "#modules/cart/items/cartItem"
import { CartItemList } from "#modules/cart/list/cartItemList"

export function CartContentOptimisticGuard({ children, classNames }: { children: ReactNode; classNames: string }) {
  const { optimisticCart } = useShoppingContext()

  if (!optimisticCart) return children

  return <CartItemList shoppingCart={optimisticCart} CartItemFC={CartItem} unModifiable={false} classNames={classNames} />
}
